import { render, staticRenderFns } from "./ServiceCenterRoutes.vue?vue&type=template&id=0a4976dc&scoped=true&"
import script from "./ServiceCenterRoutes.vue?vue&type=script&lang=js&"
export * from "./ServiceCenterRoutes.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCenterRoutes.vue?vue&type=style&index=0&id=0a4976dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4976dc",
  null
  
)

export default component.exports